import styled from 'styled-components';

import { mediaQuery } from '../../../styles/global';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.01) 100%);
  flex-grow: 1;
`;

const Container = styled.a`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  min-height: 10rem;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  transition: background 0.3s ease-in-out;
  border-radius: 0.5rem;
  max-width: 380px;
  border: 1px solid rgba(255, 255, 255, 0.1);

  ${mediaQuery.minWidth.tablet} {
    width: 25rem;
  }
  &:hover {
    ${Content} {
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.2) 0%,
        rgba(255, 255, 255, 0.08) 100%
      );
    }
  }
`;

const Text = styled.h3`
  margin-top: 10px;
  flex-grow: 1;
  font-size: 1.3rem;
  height: 100%;
`;

const TextURL = styled.p`
  flex: 1;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.75);
`;

const Img = styled.div<{ src: string }>`
  background-image: url(${({ src }) => src});
  border-radius: 8px 8px 0 0;
  width: 100%;
  height: 180px;
  background-size: cover;
  background-position: center;
  flex-grow: 1;
`;

export interface ArticleProps {
  text: string;
  url: string;
  site: string;
  img?: string;
}

const Article: React.FC<ArticleProps> = ({ text, url, site, img }) => {
  return (
    <Container href={url} target="_blank">
      {img && <Img src={img} />}
      <Content>
        <Text>{text}</Text>
        <TextURL>{site}</TextURL>
      </Content>
    </Container>
  );
};

export default Article;
